<template>
  <div class="card border-2 p-4 pb-0 bg-white hover:border-secondary transition duration-300">
    <div class="flex flex-row flex-no-wrap justify-between">
      <button
        @click="handleContentClicked"
        class="flex-none w-4/5"
        :alt="lockedOutAlt">
        <div>
          <picture v-if="sco.cover_image.jpg_url">
            <source
              :srcset="sco.cover_image.webp_url"
              type="image/webp" />
            <source
              :srcset="sco.cover_image.jpg_url"
              type="image/jpg" />
            <img
              :src="sco.cover_image.jpg_url"
              :alt="sco.title"
              class="w-full"
              loading="lazy" />
          </picture>
          <div
            class="missing-sco-image-wrapper"
            v-else>
            <div class="missing-sco-image">
              {{ sco.title }}
            </div>
          </div>
          <h2 class="text-sm font-medium my-4 text-light-grey h-12 overflow-auto">{{ sco.title }}</h2>
          <div class="h-8">
            <h3
              class="text-xs"
              v-if="hasCareOf">
              {{ careOf }}
            </h3>
          </div>
          <div class="h-8">
            <h3
              class="text-xs text-red-500"
              v-if="daysLeft && notFinished && !postTrainingDaysExpired">
              only {{ daysLeft }} day<template v-if="daysLeft > 1">s</template> left to take the assessment.
            </h3>
            <h3
              class="text-xs text-red-500"
              v-if="postTrainingDaysExpired">
              NO TIME LEFT - ASSESSMENT LOCKED OUT
            </h3>
          </div>
        </div>
      </button>
      <div class="pl-4 text-right text-light-grey">
        <ul class="text-primary icon-list">
          <!-- <li v-if="feedbackAllowed" class="icon-list-item">
                        <sco-user-feedback :sco="sco" class="icon-wrapper"></sco-user-feedback>
                    </li> -->
          <li
            v-if="reportAllowed"
            class="icon-list-item">
            <sco-report
              :sco="sco"
              class="icon-wrapper"></sco-report>
          </li>
          <li
            v-if="competencyReportAllowed"
            class="icon-list-item text-black">
            <sco-competency-report
              :sco-user-id="sco.sco_user_id"
              class="icon-wrapper"></sco-competency-report>
          </li>
          <li
            v-if="certificateAllowed"
            class="icon-list-item">
            <sco-certificate
              :course-user-id="sco.course_user_id"
              class="icon-wrapper"></sco-certificate>
          </li>
          <li
            :title="statusText"
            class="icon-list-item">
            <div class="icon-wrapper">
              <component
                class="h-6 w-6"
                :is="statusIconComponentName"
                :class="{ 'text-secondary': statusIconComponentName === 'IconStarted' }" />
            </div>
          </li>
          <li
            v-if="score"
            class="text-xs text-center">
            Score<br />{{ score }}%
          </li>
          <li
            v-if="certificateAllowed"
            class="text-xs text-center">
            {{ statusText }}<br />{{ dateFinished }}
          </li>
        </ul>
      </div>
    </div>
    <teleport to="body">
      <confirm-modal
        :is-visible="confirmModal.visible"
        :title="confirmModal.title"
        :message="confirmModal.message"
        :hide-cancel-button="true" 
        @confirm="confirmModal.visible=false"
        />
    </teleport>
  </div>
</template>

<script>
import ScoMixin from "@/components/courses/ScoMixin";

export default {
  name: "ScoCard",
  mixins: [ScoMixin],
  data() {
    return {
      preparingReport: false,
      showReport: false
    };
  },
  computed: {
    hasCareOf() {
      return this.sco.group_id || this.sco.subgroup_id || this.sco.virtual_group_id;
    },
    careOf() {
      if (this.sco.virtual_group_id) {
        let virtualGroup = this.$store.getters.getVirtualGroupById(this.sco.virtual_group_id);
        if (virtualGroup) {
          return virtualGroup.title;
        }
      }

      if (this.sco.subgroup_id) {
        let subgroup = this.$store.getters.getSubgroupById(this.sco.subgroup_id);
        if (subgroup) {
          return subgroup.title;
        }
      }

      if (this.sco.group_id) {
        let group = this.$store.getters.getGroupById(this.sco.group_id);
        if (group) {
          return group.title;
        }
      }

      return "";
    }
  }
};
</script>

<style lang="postcss">
.card {
  min-height: 400px;
}
.icon-wrapper {
  @apply flex flex-row justify-center items-center h-12 w-12 
    rounded-lg border border-gray-200 hover:border-secondary;
}
.icon-list-item {
  @apply flex flex-row justify-end mb-2;
}

.missing-sco-image-wrapper {
  width: 100%;
  height: 0;
  padding-bottom: 70%;
  @apply border-primary;
  @apply border-t-4;
  @apply border-b-8;
  @apply relative;
}
.missing-sco-image {
  @apply absolute;
  @apply inset-0;
  @apply flex;
  @apply flex-row;
  @apply justify-center;
  @apply items-center;
  @apply text-center;
}
</style>
